
const VacationAds = () => {
    return (
        <>
            <div className=' display-mini display-mob'>
                <div className=" text-center mb-2">
                    <div className=" lh-sm">
                        <b className=" text-uppercase text-ads fst-italic fw-boldest letter-spacing-2 text-2xl">
                            Summer Sale
                        </b>
                    </div>
                    <div className=" mt-3">
                        <div className=" d-flex justify-content-center align-items-center gap-2">
                            <div className=" col-5">
                                <div className=" card border-radius-lg">
                                    <div className=" p-2 lh-1 mt-2">
                                        <div>
                                            <b>Top</b>
                                        </div>
                                        <b className=" text-info fw-normal text-xxs fw-bolder letter-spacing-2 text-uppercase">
                                            Deals
                                        </b>
                                    </div>
                                    <div>
                                        <b className=" text-black fw-normal">Family Trips</b>
                                        <div className=" mt-2">
                                            <img
                                                src="https://static.vecteezy.com/system/resources/previews/024/190/836/non_2x/travel-orange-suitcase-striped-beach-bag-sunglasses-tropical-palm-leaves-tourism-summer-vacation-watercolor-illustration-isolated-png.png"
                                                alt=""
                                                height={195}
                                                className=" object-fit-contain w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" col-3">
                                <div className=" card border-radius-lg mb-2">
                                    <div className=" mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xxs">
                                                Bath & <br /> Body Care
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://cdn.grofers.com/app/images/collections/asset_Skin_&_face_(1)_1710665369044"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className=" card border-radius-lg">
                                    <div className=" mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                Sports <br /> & Activites
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://png.pngtree.com/png-clipart/20240715/original/pngtree-sport-football-soccer-at-field-png-image_15563282.png"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-1 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" col-3">
                                <div className=" card border-radius-lg mb-2">
                                    <div className="mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                PC Games <br /> & Accessories
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://theitgear.com/uploads/products/product_1772885674.webp"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className=" card border-radius-lg">
                                    <div className="mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                Children's <br />Books
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://www.bbassets.com/media/uploads/p/l/40304280_1-dreamland-number-writing-book-children-early-learning-age-3-168-pages.jpg"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VacationAds